import { Box, Grid, Tab, Tabs } from "@mui/material";
import React from "react";
import Purchase from "../purchase/purchase";
import Stocks from "../stocks/stocks";
import { useSelector } from "react-redux";

import Candidate from "./candidates";
import Posts from "./Posts";
import AppliedCandidate from "./AppliedCandidate";
// import InstituteInformation from "./instituteInformation";
// import Course from "./Course";
// import Enquiries from "./appliedCandidate";

export const JobHiringPost = ({}) => {
  const [value, setValue] = React.useState("all");
  const [appliedCandidate, setAppliedCandidate] = React.useState(null);
  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          {(!businessChooseTab || businessChooseTab?.value == "candidates") && (
            <Candidate />
          )}
          {/* {(!businessChooseTab || businessChooseTab?.value == "posts") && (
            <Posts />
          )} */}

          {businessChooseTab?.value == "posts" && (
            <>
              {!appliedCandidate && (
                <Posts
                  clickappliedCandidate={(da) => {
                    setAppliedCandidate(da);
                  }}
                />
              )}
              {appliedCandidate && (
                <AppliedCandidate
                  appliedCandidate={appliedCandidate}
                  backPost={() => {
                    setAppliedCandidate(null);
                  }}
                />
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
